var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArbitrum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#1B4ADD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 22.8L12.12 14.24H14.93L11.81 22.8H9Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.64 9.2L22.42 22.8H19.49L13.71 9.2H16.64Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.41 22.8L17.53 14.24H20.33L17.21 22.8H14.41Z",
    fill: "#28A0F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.77 9.86L22.53 13.22L18.61 9.86H23.77Z",
    fill: "#9ED4FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArbitrum);
export default __webpack_public_path__ + "static/media/arbitrum.8b1d17c5e56b9c49b50509a7e2e49dd1.svg";
export { ForwardRef as ReactComponent };